module.exports = __webpack_public_path__ + "img/io.05eb1aa5.png";